'use client';

import { Box, Button, Typography } from '@mui/material';
import { useUserContext } from '@/app/context/UserContext';
export function CompanyAccessDisabledScreen() {
  const {
    clearUser
  } = useUserContext();
  const handleLogout = () => {
    clearUser();
    setTimeout(() => {
      window.location.replace('/auth/logout');
    }, 100);
  };
  return <Box className="flex min-h-screen w-full flex-col items-center justify-center gap-6 bg-page text-foreground">
            <div className="w-80 mx-auto flex flex-col items-center justify-center gap-4">
                <Typography variant="h6" component="h1" align="center" fontWeight={600}>
                    Invalid Account
                </Typography>
                <Typography variant="body1" color="text.secondary" align="center" sx={{
        maxWidth: 480
      }}>
                    You do not have an active login access. Please contact your administrator for assistance.
                </Typography>
                <Button variant="contained" color="error" disableElevation onClick={handleLogout} fullWidth>
                    Logout
                </Button>
            </div>
        </Box>;
}